import { FontFamily } from "../../constants";

export const BUTTON_VARIANT = {
  clear: "clear",
  default: "default",
  link: "link",
  outline: "outline",
};

export const BUTTON_COLOR = {
  grayDark: "gray-dark",
  icon: "icon",
  light: "light",
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  quaternary: "quaternary",

  egw: "egw",
  references: "references",
  apl: "apl",
  bible: "bible",

  searchSectionPrimary: "search-section-primary",
  headerItem: "header-item",
};

export const BUTTON_FONT_FAMILY = FontFamily;

export const BUTTON_SIZES = {
  default: "size-default",
  small: "small",
  medium: "medium",
  big: "big"
};

export const BUTTON_MIN_WIDTH = {
  md: "min-width_md",
  lg: "min-width_lg",
};

export const MapButtonFontFamilyToCN = {
  [FontFamily.bebas]: "bebas",
  [FontFamily.roboto]: "roboto"
};
